import React, { useState, useContext, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../../themes/theme";
import { ThemeContext } from "../../../context/ThemeContext";
import { CitationItem } from "./CitationItem";

export const CitationSelection = ({
  citations,
  onSelectionChange,
  checkedIDs,
  disabled,
}) => {
  const { darkMode } = useContext(ThemeContext);
  const [selectedIDs, setSelectedIDs] = useState(new Set()); // Manage selected IDs

  useEffect(() => {
    if (checkedIDs !== null) {
      const checkedNames = new Set(checkedIDs.map((item) => item.name)); // Get all names from checkedIDs

      const newCheckIDs = new Set(
        citations
          .filter((citation) => checkedNames.has(citation.name)) // Match by name
          .map((citation) => citation.id) // Collect citation.id
      );

      setSelectedIDs(newCheckIDs);
    }
  }, [checkedIDs, citations]); // Only run when checkedIDs changes

  useEffect(() => {
    // Notify the parent component whenever checkedItems changes
    const checkedCitations = citations.filter((citation) =>
      selectedIDs.has(citation.id)
    );
    onSelectionChange(checkedCitations);
  }, [selectedIDs, citations, onSelectionChange]);

  const handleCheck = (id, isChecked) => {
    setSelectedIDs((prev) => {
      const updated = new Set(prev);
      if (isChecked) {
        updated.add(id);
      } else {
        updated.delete(id);
      }
      return updated;
    });
  };

  return (
    <Box sx={{ mb: 8, display: citations?.length > 0 ? "block" : "none" }}>
      <Typography
        display={!disabled ? "block" : "none"}
        sx={{
          fontFamily: "Poppins",
          fontSize: "28px",
          fontWeight: 500,
          color: darkMode
            ? getColors.drawerTextDark
            : getColors.thumbnailTextLight,
        }}
      >
        Citations
      </Typography>
      <Box
        display={!disabled ? "grid" : "none"}
        gap={4}
        sx={{
          mt: 5,
          gridTemplateColumns: {
            xs: "repeat(1, minmax(0, 1fr))",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(1, minmax(0, 1fr))",
            lg: "repeat(2, minmax(0, 1fr))",
            xl: "repeat(3, minmax(0, 1fr))",
          },
        }}
      >
        {citations?.map((citation, index) => (
          <CitationItem
            key={index}
            id={citation.id}
            name={citation.name}
            isChecked={!disabled && selectedIDs.has(citation.id)} // Check if the item is selected
            onCheck={handleCheck} // Handle checkbox toggle
            disabled={disabled}
          />
        ))}
      </Box>
    </Box>
  );
};
